/** Shared domain types for Delivery parsing, scoring, and Pathfinder messaging. */

/** Normalized answer after Delivery API parsing */
export interface QuizAnswer {
  text: string;
  /** Maps to eCEAnswerResult — must match a result name for scoring */
  resultLabel: string;
  weight: number;
}

export interface QuizQuestion {
  text: string;
  answers: QuizAnswer[];
}

export interface QuizResult {
  name: string;
  description: string;
}

/** Validated config used by the widget (exactly seven in-widget questions). */
export interface QuizConfig {
  quizTitle: string;
  articleUrl: string;
  questions: [QuizQuestion, QuizQuestion, QuizQuestion, QuizQuestion, QuizQuestion, QuizQuestion, QuizQuestion];
  results: QuizResult[];
}

/** postMessage payload from Pathfinder when the extended flow (Q8–10 + offer) completes */
export interface PathCompleteMessage {
  type: 'PATH_COMPLETE';
  /** Optional echo / analytics — ignored for scoring */
  payload?: Record<string, unknown>;
}

/** Narrowing guard for iframe `postMessage` payloads from Pathfinder. */
export function isPathCompleteMessage(data: unknown): data is PathCompleteMessage {
  if (data === null || typeof data !== 'object') return false;
  const o = data as Record<string, unknown>;
  return o.type === 'PATH_COMPLETE';
}
